import { UI_PERMISSION_KEY } from "pages/Roles/newFeaturesAndPermissionsData";

// BM-9524: what the current user may do with integrations.
//
// Nothing is restricted unless the both::integration_role_permissions flag is on
// for the account, or when an admin is impersonating the account (the API lets
// admins do everything too). The integration logs come with View, same as the API.
const FULL_ACCESS = Object.freeze({
  flagOn: false,
  enforced: false,
  canView: true,
  canManage: true,
});

export const getIntegrationPermissions = ({ flagOn, isAdmin, rolePermissions }) => {
  if (!flagOn || isAdmin) {
    return { ...FULL_ACCESS, flagOn: !!flagOn };
  }

  const isActive = (uiKey) => !!(rolePermissions || []).find(perm => perm.ui_key === uiKey)?.isActive;
  const canManage = isActive(UI_PERMISSION_KEY.MANAGE_INTEGRATIONS);
  const canView = canManage || isActive(UI_PERMISSION_KEY.VIEW_INTEGRATIONS);

  return {
    flagOn: true,
    enforced: true,
    canView,
    canManage,
  };
};

// Route guard for /integrations/*: the list, an integration's page and its logs
// need View (they open read-only without Manage); creating needs Manage.
export const isIntegrationRouteForbidden = (pathname, integrationPermissions) => {
  const [, section, subPage] = (pathname || "").split("/");
  if (section !== "integrations") return false;
  if (!integrationPermissions.canView) return true;
  if (subPage === "create") return !integrationPermissions.canManage;
  return false;
};
